import { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarIcons from "./SidebarIcons";

import { useParams, useNavigate, generatePath } from "react-router-dom";
import { useSelector } from "react-redux";
import { GET_DOOR_INSPECTION_AUDIT_TRAIL } from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";

export default function AuditRail() {
  const {
    inspectionMasterId,
    inspectionRefnumber,
    propertyMasterId,
    doorRefNumber,
    clientNameParam,
  } = useParams();
  const [hideSidebar, setHideSidebar] = useState(true);
  const { userObj } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [summary, setSummary] = useState({});

  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleBack = () => {
    navigate(
      generatePath(
        "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber",
        {
          clientNameParam,
          propertyMasterId,
          inspectionRefnumber,
        }
      )
    );
  };

  useEffect(() => {
    const fetchBookingHistory = async () => {
      try {
        setLoading(true);

        const { data } = await http.get(GET_DOOR_INSPECTION_AUDIT_TRAIL, {
          params: {
            DoorReferenceNumber: doorRefNumber,
            InspectionReferenceNumber: inspectionRefnumber,
          },
        });
        const getIcon = (eventType) => {
          switch (eventType) {
            case "Door Inspected":
              return "fa-solid fa-magnifying-glass";
            case "Request for Change":
              return "fa-solid fa-clipboard-check";

            case "Approved":
              return "fa-solid fa-circle-check";

            default:
              return "fa-solid fa-circle-info";
          }
        };
        const summaryData = data?.summaries?.[0] || {};
        setSummary(summaryData);

        const formattedSteps = data?.events?.map((item) => ({
          icon: getIcon(item.eventType),
          title: item.eventType,
          date: item.eventDate,
          boxText: item.performedBy
            ? `${item.eventType} by - ${item.performedBy}`
            : item.eventType,
          highlight: false,
        }));

        setSteps(formattedSteps || []);
      } catch (err) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: err?.message,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBookingHistory();
  }, [userObj?.clientId, inspectionMasterId]);

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-2">
            <div className="booking-history-container mt-1 px-4">
              {/* Header */}
              <h1 className="page-title">Door Inspection History</h1>

              {/* Unique ID + Report */}
              <div className="detailchek mt-5 mb-3">
                <div className="detail-row mt-3">
                  <div>
                    <strong>Inspection Ref. No:</strong> {inspectionRefnumber}
                  </div>
                  <div>
                    <strong>Door Ref. No:</strong> {doorRefNumber}
                  </div>
                  <div>
                    <strong>Inspection Managed By:</strong>{" "}
                    {summary?.inspectionManagedBy}
                  </div>
                  <div>
                    <strong>Property Name:</strong>
                    {summary?.propertyName}
                  </div>
                </div>

                {/* Timeline */}

                <div className="issues-summary">
                  <div className="detail-row mt-3">
                    <div>
                      <strong>Total Critical Issues:</strong>{" "}
                      {summary?.totalCriticalIssues || 0}
                    </div>
                    <div>
                      <strong>Total Non Compliant Issues:</strong>{" "}
                      {summary?.totalNonCompliantIssues || 0}
                    </div>
                  </div>
                </div>

                <div className="timeline">
                  {loading ? (
                    <p>Loading timeline...</p>
                  ) : steps.length > 0 ? (
                    steps.map((step, index) => (
                      <div className="timeline-item-row" key={index}>
                        {/* LEFT SIDE: icon + title + date */}

                        <div className="timeline-left">
                          <div className="timeline-icon">
                            {step.icon === "dot" ? (
                              <div className="dot"></div>
                            ) : (
                              <i className={step.icon}></i>
                            )}
                          </div>
                          <div className="timeline-info">
                            <div
                              className={`inspection-title-after ${
                                step.highlight ? "text-danger fw-semibold" : ""
                              }`}
                            >
                              {step.title}
                            </div>
                            <div className="inspection-date">{step.date}</div>
                          </div>
                        </div>

                        {/* RIGHT SIDE: box */}
                        <div
                          className="inspection-box"
                          style={{ backgroundColor: "#e9ecef" }}
                        >
                          <span>{step.boxText}</span>
                          <span className="dropdown-arrow">▼</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No booking history found.</p>
                  )}
                </div>
                <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      handleBack();
                    }}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      )}
    </>
  );
}
